import { getText, post, postBlob } from "../../../components/hooks/apiFetch";

export const fetchFullText = async (inputIdentifier, fileName, version, baseFileId) => {
    const url = `/api/OperationInfo/FullText/${encodeURIComponent(inputIdentifier)}?fileName=${encodeURIComponent(fileName)}&version=${encodeURIComponent(version)}&baseFileId=${encodeURIComponent(baseFileId)}`
    const text = await getText(url);
    return text;
};

export const updateText = async (inputIdentifier, fileName, oldVersion, baseFileId, content) => {
    const bodyContent = {
        inputIdentifier,
        fileName,
        oldVersion,
        baseFileId,
        content
    }
    const data = await post(`/api/FileChanges/SaveNewVersion`, bodyContent);
    return data;
};

export const downloadEdited = async (fileName, baseFileId, content) => {
    const blob = await postBlob(`/api/FileChanges/DownloadEdited?fileName=${encodeURIComponent(fileName)}&baseFileId=${encodeURIComponent(baseFileId)}`, content);
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName.endsWith('.txt') ? fileName : `${fileName}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    setTimeout(() => URL.revokeObjectURL(url), 100);
};

export const uploadNewFileVersion = async ({
    inputIdentifier,
    fileName,
    oldVersion,
    baseFileId,
    file
}) => {
    const formData = new FormData();
    formData.append('inputIdentifier', inputIdentifier);
    formData.append('fileName', fileName);
    formData.append('oldVersion', String(oldVersion));
    formData.append('baseFileId', baseFileId);
    formData.append('file', file);
    const result = await post('/api/FileChanges/SaveNewFileVersion', formData);
    return result;
};